import { css } from '@emotion/css';
import { theme } from '../../../../../electrons';
const title = css `
  color: ${theme.colors.text[600]};
`;
const tabContainer = css `
  max-width: 220px;
`;
const fieldContainer = css `
  margin-top: 8px;
`;
const urlFieldContainer = css `
  margin-top: 8px;
  max-width: 418px;
`;
export const CenterLogoStyles = {
    title,
    tabContainer,
    fieldContainer,
    urlFieldContainer,
};
//# sourceMappingURL=CenterLogo.styles.js.map